.layout {
    font-family: 'Space Grotesk', sans-serif;
    color: var(--text-primary);
    
    background-color: var(--bg-primary);
    background-image: 
        linear-gradient(rgba(0, 240, 255, 0.05) 1px, transparent 1px),
        linear-gradient(90deg, rgba(0, 240, 255, 0.05) 1px, transparent 1px);
    background-size: 32px 32px;
    background-position: center;
    
    height: calc(100vh - 65px); /* 减去顶部 tabbar 等占位高度 */
    min-height: 800px;
    max-height: calc(100vh - 65px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.layout ::selection {
    background: var(--accent-cyan);
    color: var(--bg-primary);
}

.mainGrid {
    flex-grow: 1;
    padding: 1.5rem;
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.5rem;
    position: relative;
    z-index: 10;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

@media (min-width: 1024px) {
    .mainGrid {
        grid-template-columns: 1fr 2fr 1fr;
    }
}

@media (min-width: 1536px) {
    .mainGrid {
        grid-template-columns: 1fr 3fr 1fr;
    }
}

.leftCol, .rightCol {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    height: 100%;
    overflow: hidden;
}

.leftCol > *:last-child {
    margin-top: auto;
}

.centerCol {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    overflow: hidden;
    width: 100%;
}

.brutalPanel {
    background-color: var(--bg-surface);
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.brutalPanelAccent {
    background-color: var(--bg-surface);
    border: 1px solid var(--accent-cyan);
    box-shadow: 0 0 10px rgba(0, 240, 255, 0.1);
}

.panelContent {
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;
    min-height: 0;
}

.panelHeader {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    border-bottom: 1px solid var(--border);
    padding-bottom: 0.75rem;
    margin-bottom: 1rem;
    flex-shrink: 0;
}

.panelTitle {
    font-size: 1.25rem;
    color: var(--text-primary);
    text-transform: uppercase;
    font-weight: 600;
    margin: 0;
}

.panelTitleSm {
    font-family: var(--font-code);
    font-size: 0.875rem;
    color: var(--accent-cyan);
    text-transform: uppercase;
    letter-spacing: 0.1em;
    margin: 0;
}

.panelSubtitle {
    font-family: var(--font-code);
    font-size: 0.75rem;
    color: rgba(0, 240, 255, 0.5);
    font-weight: 700;
}

.treeList {
    list-style: none;
    padding: 0;
    margin: 0;
    font-family: var(--font-code);
    font-size: 0.875rem;
    color: var(--text-secondary);
}

.treeItem {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
    cursor: pointer;
    transition: color 0.2s;
}
.treeItem:hover {
    color: var(--accent-cyan);
}
.treeItem.active {
    color: var(--accent-cyan);
    font-weight: bold;
}

.treeSubList {
    padding-left: 1.5rem;
    border-left: 1px solid var(--border);
    margin-left: 9px;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.treeSubItem {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    transition: color 0.2s;
}
.treeSubItem:hover {
    color: var(--accent-cyan);
}

.statRow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: var(--font-code);
    font-size: 0.75rem;
    margin-bottom: 0.5rem;
}
.statLabel { color: var(--text-secondary); }
.statValue { color: var(--accent-cyan); }

.progressBar {
    display: flex;
    gap: 2px;
    margin-bottom: 1rem;
}
.progressSegment {
    height: 6px;
    flex: 1;
    background-color: var(--border);
}
.progressSegment.filled {
    background-color: var(--accent-cyan);
}

.asciiArt {
    font-family: 'Consolas', 'Courier New', monospace;
    font-size: clamp(0.4rem, 1.2vw, 0.75rem);
    color: var(--accent-cyan);
    text-shadow: 0 0 10px rgba(0, 240, 255, 0.2);
    line-height: 1;
    letter-spacing: 0;
    white-space: pre;
    text-align: center;
    margin: 0;
}

.asciiContainer {
    padding: 1.5rem;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid var(--border);
}

.execButton {
    font-family: var(--font-code);
    font-size: 0.75rem;
    color: var(--bg-primary);
    background-color: var(--accent-cyan);
    padding: 0.5rem 1rem;
    text-transform: uppercase;
    font-weight: 700;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s;
    flex-shrink: 0;
}

.execButton:hover {
    background-color: var(--text-primary);
}

.avatarBox {
    width: 100%;
    aspect-ratio: 4/5;
    background-color: var(--bg-elevated);
    position: relative;
    padding: 4px;
    flex-shrink: 0;
}

.charBracketTl { position: absolute; top: 0; left: 0; width: 10px; height: 10px; border-top: 2px solid var(--accent-cyan); border-left: 2px solid var(--accent-cyan); }
.charBracketTr { position: absolute; top: 0; right: 0; width: 10px; height: 10px; border-top: 2px solid var(--accent-cyan); border-right: 2px solid var(--accent-cyan); }
.charBracketBl { position: absolute; bottom: 0; left: 0; width: 10px; height: 10px; border-bottom: 2px solid var(--accent-cyan); border-left: 2px solid var(--accent-cyan); }
.charBracketBr { position: absolute; bottom: 0; right: 0; width: 10px; height: 10px; border-bottom: 2px solid var(--accent-cyan); border-right: 2px solid var(--accent-cyan); }

.avatarId {
    position: absolute;
    top: 12px;
    left: 12px;
    z-index: 10;
    font-family: var(--font-code);
    font-size: 10px;
    color: var(--bg-primary);
    background-color: var(--accent-cyan);
    padding: 2px 6px;
    font-weight: 700;
}

.avatarStatus {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 10;
    display: flex;
    align-items: center;
    gap: 6px;
}

.statusDot {
    width: 6px;
    height: 6px;
    background-color: var(--accent-cyan);
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.statusText {
    font-family: var(--font-code);
    font-size: 10px;
    color: var(--accent-cyan);
    font-weight: 700;
}

.avatarImageWrapper {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: flex-end;
}

.avatarLoadingOverlay {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(10, 10, 15, 0.85);
    backdrop-filter: blur(3px);
    z-index: 5;
    gap: 1.25rem;
}

.glitchText {
    font-family: var(--font-code);
    color: var(--accent-cyan);
    font-size: 11px;
    letter-spacing: 0.15em;
    font-weight: 700;
    animation: glitch-anim 2s infinite;
}

.loadingBarContainer {
    width: 65%;
    height: 3px;
    background-color: rgba(0, 240, 255, 0.1);
    position: relative;
    overflow: hidden;
}

.loadingBarFill {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 40%;
    background-color: var(--accent-cyan);
    box-shadow: 0 0 10px var(--accent-cyan);
    animation: loading-slide 1.5s infinite ease-in-out;
}

.avatarImage {
    width: 100%;
    height: 100%;
    display: block;
}

.avatarOverlay {
    position: absolute;
    inset: 0;
    border: 1px solid rgba(0, 240, 255, 0.2);
    margin: 8px;
    pointer-events: none;
}

.avatarVersion {
    position: absolute;
    bottom: 8px;
    left: 8px;
    background-color: var(--bg-primary);
    border: 1px solid var(--border);
    padding: 2px 8px;
}
.avatarVersionText {
    font-family: var(--font-code);
    font-size: 10px;
    color: var(--accent-cyan);
}

.logsContainer {
    flex-grow: 1;
    overflow-y: auto;
    font-family: var(--font-code);
    font-size: 11px;
    color: var(--text-secondary);
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-right: 0.5rem;
    -webkit-mask-image: linear-gradient(to bottom, transparent 0px, black 40px, black calc(100% - 20px), transparent 100%);
    mask-image: linear-gradient(to bottom, transparent 0px, black 40px, black calc(100% - 20px), transparent 100%);
}

.logsContainer > :first-child {
    margin-top: auto;
}

.logTime {
    color: rgba(0, 240, 255, 0.5);
    flex-shrink: 0;
}

.badgeRec {
    font-family: var(--font-code);
    font-size: 10px;
    background-color: var(--accent-cyan);
    color: var(--bg-primary);
    padding: 2px 6px;
    font-weight: 700;
}

.termScrollbar {
    scrollbar-width: thin;
    scrollbar-color: var(--border) transparent;
}
.termScrollbar::-webkit-scrollbar {
    width: 4px;
}
.termScrollbar::-webkit-scrollbar-track {
    background: transparent;
}
.termScrollbar::-webkit-scrollbar-thumb {
    background: var(--border);
}

.logLine {
    display: flex;
    gap: 0.5rem;
}
.logTextFixed { color: var(--accent-cyan); }
.logTextSurface { color: var(--text-primary); }
.logTextVariant { color: var(--text-secondary); }
.logTextFaded { opacity: 0.5; }
.logTextDim { opacity: 0.3; }

@keyframes blink { 0%, 100% { opacity: 1; } 50% { opacity: 0; } }
@keyframes pulse { 50% { opacity: .5; } }

@keyframes glitch-anim {
    0% { opacity: 1; transform: skewX(0deg); }
    90% { opacity: 1; transform: skewX(0deg); }
    92% { opacity: 0; transform: skewX(10deg); }
    94% { opacity: 1; text-shadow: 2px 0 red, -2px 0 blue; transform: skewX(-10deg); }
    96% { opacity: 0; transform: skewX(0deg); }
    98% { opacity: 1; text-shadow: none; }
    100% { opacity: 1; }
}

@keyframes loading-slide {
    0% { left: -40%; }
    100% { left: 100%; }
}

.icp {
  position: fixed;
  bottom: 0;
  right: 0;
  font-size: 10px;
  color: var(--bg-surface);
  z-index: 10;
}

.icp a {
  color: inherit;
  text-decoration: none;
}
